import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import CourseModal from "../CourseDetail/CourseModal/container";
import Content from "./Content/container";
import "./style.less";

export type MapProps = RootContainerProps & {};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_member_course_list" {...getContainerProps(props)}>
    <Content {...getRootContainerProps(props)} />

    <CourseModal {...getRootContainerProps(props)} />
  </Container>
);
